import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { CacheService } from 'mapfre-auditlib';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: "root"
})
export class TerritorialAreaService {

  className = 'TerritorialAreaService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getAllAreas(cache = true, cacheKey = "allTerritorialAreas"): Observable<any[]> | any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<any[]>(environment.base_URL + "/territorial-area").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newArea(area) {
    return this.http.post(environment.base_URL + "/territorial-area", area)
  }

  updateArea(area, id) {
    return this.http.put(environment.base_URL + `/territorial-area/${id}`, area)
  }
}